<i18n>
{
	"en": {
		"search": "Search",
		"searchForArea": "Search for areas",
		"orderInsideArea": "Order inside area",
		"orderOutsideArea": "Order outside area",
		"defineNewArea": "Define new area",
		"cancel": "Cancel",
		"selectAreas": "Select areas",
		"selectOrdersFromArea": "Select orders from area",
		"selectOrdersToArea": "Select orders to area",
		"areaLocation": "Area/Location",
		"extendedSearchRadius": "Extended Search Radius",
		"results": "None found | {count} results",
		"areaDefine": "Define area",
		"outside": "Outside",
		"inside": "Inside"
	},
	"no": {
		"search": "Søk",
		"searchForArea": "Søk etter områder",
		"orderInsideArea": "Oppdrag innenfor området",
		"orderOutsideArea": "Oppdrag utenfor området",
		"defineNewArea": "Definer nytt område",
		"cancel": "Avbryt",
		"selectAreas": "Velg områder",
		"selectOrdersFromArea": "Velg ordre fra område",
		"selectOrdersToArea": "Velg ordre til område",
		"areaLocation": "Sted/område",
		"extendedSearchRadius": "Utvidet søkeradius",
		"results": "Ingen resultater | {count} resultater",
		"areaDefine": "Definer område",
		"outside": "Utenfor",
		"inside": "Innenfor"
	}
}
</i18n>
<template>
	<div class="dialog-grid-container">
		<t-grid
			ref="grid"
			:items="filteredLocations"
			:columnDefinitions="columnDefinitions"
			:defaultColumnDefinition="defaultColumnDefinition"
			:rowHeight="40"
			:selectedIds="checkedIds"
			:showFilters="false"
			selectable
			:selectableMode="['checkbox']"
			class="dialog-grid"
			@selected="onRowsSelected"
		>
			<template v-slot:type="{ item }">
				<t-timpex-icon
					:icon="(item.type === 'polygon-filter' ? 'polygon-filter': (item.type === 'address' ? 'home' : 'map-marker'))"
					type="bp"
					color="blue"
					size="sm"
					style="padding-left: 3px;"
				/>
			</template>
			<template v-slot:op="{ item }">
				<div >
					<t-switch
						:value="areaInvert(item.op)"
						:checked="areaInvert(item.op)"
						:label="areaInvert(item.op) ? $t('outside') : $t('inside')"
						:disabled="item.type !== 'polygon-filter'"
						@change="onChangeOp(item)"
					/>
				</div>
			</template>
			<template v-slot:radiusValue="{ item }">
				<div class="dialog-slider-container">
					<t-slider
						v-model="item.radiusValue"
						class="dialog-slider"
						@change="expandArea(item)"
					/>
					<div>{{ item.radiusValue ? item.radiusValue : 0 }} km</div>
				</div>
			</template>
			<template v-slot:edit="{ item }">
				<t-icon-button
					icon="annotation"
					type="bp"
					appearance="minimal"
					iconSize="sm"
					:disabled="item.type !== 'polygon-filter'"
					@click="editArea(item)"
				/>
			</template>
			<template v-slot:delete="{ item }">
				<t-icon-button
					icon="trash"
					type="bp"
					appearance="minimal"
					iconSize="sm"
					:disabled="item.type !== 'polygon-filter'"
					@click="deleteArea(item)"
				/>
			</template>
		</t-grid>
	</div>
</template>

<script>
export default {
	name: 'LocationsDialogGrid',
	props: {
		locations: Array,
		checkedIds: Array,
	},
	data() {
		return {
			defaultColumnDefinition: { resizable: false, },
			areaToDelete: null
		};
	},
	computed: {
		columnDefinitions() {
			return [
				{
					field: 'type',
					displayName: ' ',
					width: 40,
					sortable: false
				},
				{
					field: 'title',
					displayName: this.$t('areaLocation'),
					valueGetter: item => item.name ? item.name : `${item.postalCode} ${item.postalPlace}`,
					minWidth: 200
				},
				{
					field: 'op',
					displayName: this.$t('areaDefine'),
					width: 100
				},
				{
					field: 'radiusValue',
					displayName: this.$t('extendedSearchRadius'),
					comparableValueGetter: item => item.radiusValue || 0,
					width: 170
				},
				{
					field: 'edit',
					displayName: ' ',
					width: 40,
					sortable: false
				},
				{
					field: 'delete',
					displayName: ' ',
					width: 40,
					sortable: false
				}
			];
		},
		filteredLocations() {
			if (!this.locations) return [];
			return this.locations.filter( x => x.type === 'polygon-filter' );
		},
	},
	methods: {
		areaInvert(op) {
			return op === 'NOT';
		},
		onRowsSelected(keys) {
			this.$emit('onRowsSelected', keys);
		},
		sliderValue(value, item) {
			//return; //todo properly handle?
			let pointsArray = item.area.split(' ');
			let arrayArray = [] ;
			for (let i = 0;  i < pointsArray.length; i+=2 ) {
				arrayArray.push(pointsArray.slice( i , i+2 ).reverse());
			}
		},
		onChangeOp(item) {
			this.$emit('changeOp', item);
		},
		editArea(area) {
			this.$emit('editArea', area);
		},
		deleteArea(item) {
			this.$emit('deleteArea', item);
		},
		expandArea(area) {
			this.$emit('expandArea', area);
		}
	}
};
</script>

<style lang="scss" scoped>
.dialog-grid-container{
	height: 100%;
}
.dialog-grid {
	height:100%;
	overflow-y: hidden;
}

.dialog-slider-container{
	display: flex;
	flex-direction: row;
	padding: 10px ;
	width: 100%;
}
.dialog-slider{
	margin: auto 20px auto 0;
}
.button-primary {
	margin-left: 20px;
	width: 120px !important;
}
</style>